interface subscriptionDetail {
  planUuid: string;
  billingCycle: string;
  currency: string;
}

interface subscriptionDetailStatus {
  paymentId: string;
  subscriptionId: string;
  amount: number;
}

async function getSubscriptionList() {
  const response = await fetch(`${process.env.REACT_APP_API_URL}subscription/plans`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionStorage.getItem('token')}`
    }
  });

  if (!response.ok) {
    throw new Error(`Error fetching subscription Plan detail: ${response.statusText}`);
  }

  const subscriptionPlan: any = await response.json();
  return subscriptionPlan;
}

async function getPlanDetail(uuid: string) {
  const response = await fetch(`${process.env.REACT_APP_API_URL}subscription/plan/${uuid}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionStorage.getItem('token')}`
    }
  });

  if (!response.ok) {
    throw new Error(`Error fetching subscription Plan detail: ${response.statusText}`);
  }

  const subscriptionPlan: any = await response.json();
  return subscriptionPlan;
}

async function createSubscription(details: subscriptionDetail) {
  const response = await fetch(process.env.REACT_APP_API_URL + `subscription/subscribe`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionStorage.getItem('token')}`
    },
    body: JSON.stringify(details)
  });
  // const subscriptionPlan: any = await response.json();
  return response;
}

async function updateSubscription(details: subscriptionDetail) {
  const response = await fetch(
    process.env.REACT_APP_API_URL + `subscription/update-subscriptions`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionStorage.getItem('token')}`
      },
      body: JSON.stringify(details)
    }
  );
  // const subscriptionPlan: any = await response.json();
  return response;
}

async function cancelSubscription() {
  const response = await fetch(process.env.REACT_APP_API_URL + `subscription/cancel`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionStorage.getItem('token')}`
    }
  });
  return response;
}

async function getCurrentSubscription() {
  const response = await fetch(`${process.env.REACT_APP_API_URL}subscription/current`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionStorage.getItem('token')}`
    }
  });

  if (!response.ok) {
    throw new Error(`Error fetching subscription Plan detail: ${response.statusText}`);
  }

  const subscriptionPlan: any = await response.json();
  return subscriptionPlan;
}
async function downloadInvoice(invoiceUuid: string) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/subscription/${invoiceUuid}/download`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        }
      }
    );

    if (!response.ok) {
      throw new Error('Failed to fetch invoice.');
    }

    const responseData = await response.json();
    return responseData;
  } catch (error: any) {
    console.error('Error downloading the invoice:', error?.message);
  }
}

async function updateSubscriptionStatus(details: subscriptionDetailStatus) {
  const response = await fetch(
    process.env.REACT_APP_API_URL + `subscription/update-subscription-status`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionStorage.getItem('token')}`
      },
      body: JSON.stringify(details)
    }
  );
  // const subscriptionPlan: any = await response.json();
  return response;
}

export {
  getSubscriptionList,
  getPlanDetail,
  createSubscription,
  cancelSubscription,
  getCurrentSubscription,
  updateSubscription,
  downloadInvoice,
  updateSubscriptionStatus
};
